export const InitialState = {
    EMPTY_ARRAY: [],
    EMPTY_STRING: '',
    BOOLEAN_FALSE: false,
    NUMBER_ZERO: 0,
    EMPTY_OBJECT: {},
    suggestedQuestions: [],

}
export const PageKeys = {
    Page1: 'page1'
}

export enum FilterValues {
    status = 'status',
    published = 'PUBLISHED',
    contentType = 'contentType',
    question = 'question',
    MMCQ = 8,
    ALL = 'all'
}

export const QUESTION_LIMIT = {
    ONE: 1,
    REPLACE_QUESTION: 1,
    MAX_LIMIT: 25
}

export const PROPS_REMEDIAL_KEY = {
    DEFAULT: `remedial1`
}

export const PAGE_CONTENT_TYPE = {
    QUESTION: 'Question'
}
export const REMEDIAL_PAGE_KEY = {
    QUESTION: 'question',
    VIDEO: 9,
    PAGE_STATE: 'pageState'
}

export const CONTENT_LIST_LIMIT = {
    MIN: 1,
    MAX: 5
}
